// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3gZy8","header":"ReportDetails_header__1WcI8","title":"ReportDetails_title__1pL9V","left":"ReportDetails_left__1FzfD"};